import React from 'react'

export const Policy = () => {
    return (
        <div className="tnc">
            <div className="tnc__heading">
               PRIVACY POLICY
            </div>
            <div className="tnc__heading--2">
               Your privacy is important to us.
            </div>
            <div className="policy">
                <div className="policy__content">
                It is Bunch Microtechnologies Private Limited's policy to respect your privacy regarding any information we may collect while operating our website. Accordingly, we have developed this privacy policy in order for you to understand how we collect, use, communicate, disclose and otherwise make use of personal information. We have outlined our privacy policy below.
    
    
                </div>
                <div className="policy__list">
                    <ul>
                        <li className="policy__list--item">We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.</li>
                        <li className="policy__list--item">Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.</li>
                        <li className="policy__list--item">We will collect and use personal information solely for fulfilling those purposes specified by us and for other ancillary purposes, unless we obtain the consent of the individual concerned or as required by law.</li>
                        <li className="policy__list--item">Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.</li>
                        <li className="policy__list--item">We will protect personal information by using reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.</li>
                        <li className="policy__list--item">We will make readily available to customers information about our policies and practices relating to the management of personal information.</li>
                        <li className="policy__list--item">We will only retain personal information for as long as necessary for the fulfilment of those purposes.</li>
                    </ul>
                </div>

                <div className="policy__content">
                We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained. Bunch Microtechnologies Private Limited may change this privacy policy from time to time at Bunch Microtechnologies Private Limited's sole discretion.
                </div>
            </div>
        </div>

    )
}

export default Policy